import { Action } from '@ngrx/store';

export class PayloadAction implements Action {
  type: string;

  constructor(public payload?: any) {
  }
}

export class NamedPayloadAction implements PayloadAction {
  type: string;

  constructor(public newType: string, public payload?: any) {
    this.type = newType;
  }
}
